import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  DetailActionButton,
  FormTextField,
  PrimaryDetailActionbarButton,
  SecondaryDetailActionbarButton,
} from '@eas/common-web';
import { useGenerateApiKeyDialog } from './dialog-actions/generate-api-key';
import { useDeleteApiKeyDialog } from './dialog-actions/delete-api-key';

export function ActionBar() {
  const intl = useIntl();

  const { callApi: generateApiCall, showButton: showGenerateBtn } =
    useGenerateApiKeyDialog();

  const { callApi: deleteApiCall, showButton: showDeleteBtn } =
    useDeleteApiKeyDialog();

  return (
    <>
      {showGenerateBtn && (
        <DetailActionButton
          promptKey="GENERATE_KEY"
          buttonLabel={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__ACTIONBAR__GENERATE_API_KEY',
            defaultMessage: 'Generovat Api klíč',
          })}
          dialogTitle={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__DIALOG_GENERATE_API_KEY__TITLE',
            defaultMessage: 'Generovat Api klíč',
          })}
          dialogText={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__DIALOG_GENERATE_API_KEY__TEXT',
            defaultMessage:
              'Skutečně chcete generovat Api klíč pro zvoleného uživatele?',
          })}
          apiCall={generateApiCall}
          ButtonComponent={PrimaryDetailActionbarButton}
          resultDialog={{
            title: intl.formatMessage({
              id: 'TAPIS__SYSTEM_USERS__KEY_DIALOG__FIELD_LABEL__API_KEY',
              defaultMessage:
                'Předejte zodpovědné osobě nově vygenerovaný API klíč:',
            }),
            FormFields: () => (
              <FormTextField
                name="key"
                label={
                  <FormattedMessage
                    id="TAPIS__SYSTEM_USERS__DETAIL__FIELD_LABEL__API_KEY"
                    defaultMessage="Api Klíč"
                  />
                }
                labelOptions={{ hide: true }}
                disabled
              />
            ),
          }}
        />
      )}
      {showDeleteBtn && (
        <DetailActionButton
          promptKey="DELETE_KEY"
          buttonLabel={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__ACTIONBAR__DELETE_API_KEY',
            defaultMessage: 'Smazat Api klíč',
          })}
          dialogTitle={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__DIALOG_DELETE_API_KEY__TITLE',
            defaultMessage: 'Smazat Api klíč',
          })}
          dialogText={intl.formatMessage({
            id: 'TAPIS__SYSTEM_USERS__DIALOG_DELETE_API_KEY__TEXT',
            defaultMessage:
              'Skutečně chcete smazat Api klíč pro zvoleného uživatele?',
          })}
          apiCall={deleteApiCall}
          ButtonComponent={SecondaryDetailActionbarButton}
        />
      )}
    </>
  );
}
